export class Header {
    constructor(args = {}) {
        this.headerSelector = args.headerSelector ?? '#header--site';
        this.header = document.querySelector(this.headerSelector);

        if (!this.header) {
            return;
        }

        this.staticNav = this.header.querySelector('.static-nav');
        this.scrollingNav = this.header.querySelector('.scrolling-nav');

        this.triggerPoint = 0;

        this.updateMeasurements = this.updateMeasurements.bind(this);
        this.updateHeader = this.updateHeader.bind(this);

        this.updateMeasurements();
        this.bind();
    }

    bind() {
        window.addEventListener('scroll', this.onWindowScroll);

        window.addEventListener('resize', this.onWindowResize);
    }

    updateMeasurements() {
        this.triggerPoint = this.staticNav.offsetHeight;

        this.updateHeader();
    }

    updateHeader() {
        if (window.scrollY > this.triggerPoint) {
            this.showScrollingNav();
        } else {
            this.hideScrollingNav();
        }
    }

    showScrollingNav() {
        this.scrollingNav.classList.add('is-visible');
    }

    hideScrollingNav() {
        this.scrollingNav.classList.remove('is-visible');
    }

    onWindowScroll = (event) => {
        this.updateHeader({ passive: true});
    }

    onWindowResize = (event) => {
        this.updateMeasurements();
    }
}